module.exports = __webpack_public_path__ + "static/media/Commercial.a4a64df7.png";